import clsx from "clsx";
import React, { DetailedHTMLProps, HTMLAttributes, useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { GenericApiValue } from "../../../../api-http/types";
import { Spinner } from "../../../spinner";
import { FormFieldLabel, Pill } from "../../elements";
import { TagColors, TagDimensions } from "../../elements/tags/types";
import { MaterialsApiFormFieldsLabels, MaterialsApiFormFieldsTypes } from "./types";

export interface MaterialsApiFormFieldsProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  labels: MaterialsApiFormFieldsLabels;
  optionsList: GenericApiValue[] | null;
}

export function MaterialsApiFormFields({
  labels,
  className,
  optionsList,
  ...rest
}: MaterialsApiFormFieldsProps) {
  const formMethods = useFormContext<MaterialsApiFormFieldsTypes>();
  const values = formMethods.watch("materials");

  const handleOnChange = useCallback(
    (id?: string) => {
      if (!id) return;

      let newValues = [];
      if (!values || !values?.find((value) => value === id)) {
        newValues = (values ?? []).concat([id]);
      } else {
        newValues = values.filter((value) => value !== id);
      }

      formMethods.setValue("materials", newValues);
    },
    [values, formMethods]
  );

  return (
    <div className={clsx("flex flex-col gap-2", className)} {...rest}>
      <FormFieldLabel label={labels.materials} />
      <div className="flex gap-4 w-fit flex-wrap">
        {!!optionsList ? (
          optionsList.map(
            ({ id, defaultValue }) =>
              defaultValue && (
                <Pill
                  key={id}
                  color={TagColors.Primary}
                  dimension={TagDimensions.Medium}
                  className="font-medium"
                  checked={!!values?.find((value) => value === id)}
                  onChange={() => handleOnChange(id)}
                >
                  {defaultValue}
                </Pill>
              )
          )
        ) : (
          <Spinner size="large" />
        )}
      </div>
    </div>
  );
}
